/**
 * Human-readable auth error formatting, shared by the auth screen (AuthForm).
 *
 * Extracted so it can be unit-tested without the React client component. A
 * wedged or timed-out auth gateway (e.g. a 504 from GoTrue/Kong under load) can
 * hand back an error whose `message` is blank or a raw JSON blob like "{}" —
 * rendering that straight into the form once showed users a literal "{}" (the
 * code-first auth overhaul, PR #77). Fall back to a friendly line whenever the
 * message is empty or doesn't look like prose.
 */

export const AUTH_FALLBACK_MESSAGE =
  'Something went wrong on our end. Please try again in a moment.'

export function authErrorMessage(
  error: { message?: string } | null | undefined
): string {
  const message = error?.message?.trim()
  if (!message || message === '{}' || message.startsWith('{')) {
    return AUTH_FALLBACK_MESSAGE
  }
  return message
}
